import { useMutation } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

export function useResetPassword() {
  return useMutation(orpc.auth.resetPassword.mutationOptions());
}
